const textSidebar = document.querySelectorAll('.text-sidebar');

textSidebar.forEach((menu) => {
	const mainHeadings = menu.querySelectorAll('.text h2[id]');
	const menuItems = menu.querySelectorAll('.table-of-contents a');
	const mobileSelect = menu.querySelector('select');
	const currentHash = window.location.hash.split('#')[1];

	document.addEventListener('scrollend', (e) => {
		const headerHeight = document.getElementById('site-header').offsetHeight;

		mainHeadings.forEach((heading) => {
			const top = heading.getBoundingClientRect().top - headerHeight;
			const activeItem = menu.querySelector('a[href="#' + heading.id + '"]');

			if (menu.getBoundingClientRect().top > headerHeight) {
				menuItems.forEach((item) => item.classList.remove('is-active'));
				menuItems[0].classList.add('is-active');
				mobileSelect.value = menuItems[0].href.split('#')[1];
			} else if (top < headerHeight) {
				menuItems.forEach((item) => item.classList.remove('is-active'));
				activeItem.classList.add('is-active');
				mobileSelect.value = activeItem.href.split('#')[1];
			}
		});
	});

	menuItems.forEach((item) => {
		item.addEventListener('click', () => {
			const anchorID = item.href.split('#')[1];
			mobileSelect.value = anchorID;
			menuItems.forEach((sibling) => sibling.classList.remove('is-active'));
			item.classList.add('is-active');
		});
	});

	mobileSelect.addEventListener('change', () => {
		window.location.hash = mobileSelect.value;
	});

	// Pre-load select if hash is present in URL
	if (currentHash) {
		mobileSelect.value = currentHash;
	}
});
